module.exports = __webpack_public_path__ + "img/no_data_list.340ac804.png";